function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconInfoRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 2a14 14 0 100 28 14 14 0 000-28zm0 10.15a1.52 1.52 0 01-1.14-.47 1.54 1.54 0 01-.45-1.11A1.55 1.55 0 0116 9a1.6 1.6 0 011.16.46 1.56 1.56 0 01.45 1.11 1.54 1.54 0 01-.45 1.11 1.571 1.571 0 01-1.16.47zM14.65 23v-9.77h2.66V23h-2.66z",
    fill: props.color
  }));
}

export default SvgIconInfoRexFilled;